/**
 * Inventory service - uses product API for inventory views.
 * Supports planned inventory, parts view, and quantity on hand.
 * Backend may expose dedicated inventory endpoints; extend this service as needed.
 */
export default (https) => ({
  async getManagementReport(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');
    const response = await https.get(`/inventories?${queryString}`);
    return response.data;
  },
  async getInventorForecastReport(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');
    const response = await https.get(`/inventories/forecast?${queryString}`);
    return response.data;
  },
  async getInventoryLog(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');
    const response = await https.get(`/inventories/log?${queryString}`);
    return response.data;
  },
});
